import AlphaEventDispatcher from './alpha-event-dispatcher'
import AlphaHelpers from './alpha-helpers'
import cloneDeep from 'lodash-es/cloneDeep'
import merge from 'lodash-es/merge'

export default class AlphaModule extends AlphaEventDispatcher {
  constructor(isDefault, config = {}) {
    super()

    this._default = isDefault
    this._overriden = false
    this._config = {}

    this._loadConfig(config)
  }

  getName() {
    throw new Error('You must define a module name.')
  }

  filterName(hookName) {
    return `module.${this.getName()}.${hookName}`
  }

  isDefaultModule() {
    return this._default
  }

  isOverriddenModule() {
    return this._overriden
  }

  getConfig() {
    return cloneDeep(this._config)
  }

  getDefaultConfig() {
    return {}
  }

  addConfig(config) {
    this._config = merge(this._config, config)
  }

  getDependencies() {
    return {}
  }

  _onLoad() {
    window.alpha._setModuleState(this.getName(), AlphaHelpers.getModuleStates().stateLoaded)
    this.dispatchEvent('loaded')
  }

  _loadConfig(config) {
    this._config = this.getDefaultConfig()
    if (AlphaHelpers.objectHasAnyValues(config)) {
      this.addConfig(config)
    }
  }

  _setOverridden() {
    this._overriden = true
  }
}
